import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Field } from "@progress/kendo-react-form";
import { Error } from "@progress/kendo-react-labels";
import { connect } from "react-redux";
const NumericInput = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <NumericTextBox {...others} />
      {visited && validationMessage && <Error>{validationMessage}</Error>}
    </div>
  );
};

class CLNumeric extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  componentDidMount() {
    if (this.props.isEditMode) {
      this.setState({
        value: this.props.task.value,
      });
    }
  }

  onNumericChange = (event) => {
    let obj = {
      templateName: this.props.templateName,
      sequence: this.props.sequence,
      value: event.target.value.toString(),
    };
    this.props.onChange(obj);
  };

  render() {
    let child = null;
    if (this.props.isEditMode) {
      child = (
        <Field
          style={{
            padding: 5,
            width: "50px",
          }}
          name={"numeric" + this.props.sequence}
          component={NumericInput}
          disabled={this.props.isDeleteMode}
          onChange={this.onNumericChange}
          defaultValue={this.props.task.checklistTask.value}
          value={this.state.value}
        />
      );
    } else {
      child = (
        <Field
          style={{
            padding: 5,
            width: "50px",
          }}
          name={"numeric" + this.props.sequence}
          component={NumericInput}
          disabled={this.props.isDeleteMode}
          onChange={this.onNumericChange}
          defaultValue={this.state.value}
          value={this.state.value}
        />
      );
    }

    let panel = (
      <>
        <tr className={"k-master-row"}>
          <td style={{ paddingLeft: 5 }}>
            {this.props.task.taskTemplate.name}
          </td>
          <td style={{ paddingLeft: 5 }}>
            {this.props.task.taskTemplate.description}
          </td>
          <td
            style={{
              paddingLeft: 5,
              verticalAlign: "top",
            }}
          >
            <div className={"checklistBoxes"}>{child}</div>
          </td>
        </tr>
      </>
    );
    return <React.Fragment>{panel}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CLNumeric);
